module.exports = __webpack_public_path__ + "img/tab02.edd7b121.png";